<template>
  <el-card class="day-card-items-report">
    <div class="list">
      <div :key="index" class="box box-border" v-for="(item, index) in cardData.cardItems">
        <div class="text title-info">
          <span>{{ $dataCheck(item.title) }}{{ item.currency && `(${item.currency})` }}</span>

          <Content :content="item.tooltip" :contentCustomr="item.contentCustomr"></Content>
        </div>
        <el-popover
          popper-class="chart-popover"
          placement="right-start"
          @show="showReport(item.chartKey)"
          width="560"
          trigger="hover"
        >
          <div class="popover-content">
            <div class="container">
              <div class="row">
                <div class="item">
                  <div class="title">环比时间:</div>
                  <div class="data">昨日({{ item.dayDt }})</div>
                </div>
                <div class="item">
                  <div class="title">同比时间:</div>
                  <div class="data">
                    {{ moment(item.weekDt).locale('zh-cn').format('dddd').replace(/星期/, '上周') }}({{ item.weekDt }})
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="item">
                  <div class="title">环比值:</div>
                  <div class="data">{{ item.dayValue }}{{ item.unit }}</div>
                </div>
                <div class="item">
                  <div class="title">同比值:</div>
                  <div class="data">{{ item.weekValue }}{{ item.unit }}</div>
                </div>
              </div>
              <div class="row">
                <div class="item">
                  <div class="title">环比结果:</div>
                  <div class="data" :style="item.dayRate < 0 ? 'color:#16C97B' : 'color:#F23E55'">
                    {{ item.dayRate }}%
                  </div>
                </div>
                <div class="item">
                  <div class="title">同比结果:</div>
                  <div class="data" :style="item.weekRate < 0 ? 'color:#16C97B' : 'color:#F23E55'">
                    {{ item.weekRate }}%
                  </div>
                </div>
              </div>
            </div>
            <reportCard :ref="item.chartKey" :config="configData[item.chartKey] || { height: '235px' }"></reportCard>
          </div>
          <div class="number font-manrope" slot="reference">{{ $dataCheck(item.number, 0) }}</div>
        </el-popover>
        <div class="rate-box" slot="reference">
          <span class="rate">
            <span>日环比：</span>
            <span class="font-manrope rate-number" :style="item.dayRate < 0 ? 'color:#16C97B' : 'color:#F23E55'">
              {{ $dataCheck(item.dayRate) }}%
              <!-- <i class="iconfont iconChevron-Top" style="transform: rotate(180deg)" v-if="item.dayRate < 0" />
                <i class="iconfont iconChevron-Top" v-else /> -->
            </span>
          </span>
          <span class="rate">
            <span>周同比：</span>
            <span class="font-manrope rate-number" :style="item.weekRate < 0 ? 'color:#16C97B' : 'color:#F23E55'">
              {{ $dataCheck(item.weekRate) }}%
              <!-- <i class="iconfont iconChevron-Top" style="transform: rotate(180deg)" v-if="item.weekRate < 0" />
                <i class="iconfont iconChevron-Top" v-else /> -->
            </span>
          </span>
        </div>
      </div>
    </div>
  </el-card>
</template>
<script>
import Content from './content'
import moment from 'moment'
import reportCard from '@/components/data-analysis/report'
export default {
  props: {
    cardData: {
      default: () => {
        return {
          title: [],
          cardItems: [
            { title: '成交额', currency: 'USD', number: 1, rate: 0, tooltip: '提示', tip: '' },
            {
              title: '订单量',
              currency: 'USD',
              number: 1,
              rate: 0,
              tooltip: '提示',
              tip: h => h('span', ['内容', h('a', { attr: {} }, '日报'), '你热']),
            },
            { title: '订单量', currency: 'USD', number: 1, rate: 0, tooltip: '提示', tip: '' },
          ],
        }
      },
    },
  },
  components: {
    reportCard,
    Content,
  },
  mounted() {},
  data() {
    return {
      configData: {},
    }
  },
  methods: {
    moment,
    toSetting() {
      this.$emit('toSetting')
    },
    showReport(chartKey) {
      this.$set(
        this.configData,
        chartKey,
        this.setChartConfig(
          this.cardData.trend,
          this.cardData.cardItems.find(el => el.chartKey === chartKey)
        )
      )

      console.log(this.configData[chartKey])
    },
    setChartConfig(data = [], item) {
      return {
        type: 'line',
        title: '近7天趋势 - ' + item.title,
        ref: item.chartKey || `lineChart`,
        height: '235px',
        chart: {
          grid: {
            top: '2%',
            bottom: 0,
          },
          tooltip: {
            trigger: 'axis',
            formatter: function (params) {
              var relVal =
                `<span style="display:inline-block;margin-right:5px;border-radius:10px;width:10px;height:10px;background-color:${params[0].color}"></span>` +
                params[0].name
              for (var i = 0, l = params.length; i < l; i++) {
                relVal += '<br/>' + params[i].seriesName + ' : ' + params[i].value + (item.unit || '')
              }
              return relVal
            },
          },
          xAxis: {
            data: data.map(el => el.dt),
          },
          legend: {
            show: false,
          },
          yAxis: [
            {
              type: 'value',
              min: 0,
              axisLabel: {
                formatter: '{value}' + (item.unit || ''),
              },
            },
          ],
          series: [
            {
              name: item.title,
              type: 'line',
              data: data.map(el => el[item.chartKey]),
            },
          ],
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.day-card-items-report {
  min-height: 180px;
  margin-top: 16px;
  .el-card__header {
    overflow: hidden;
    height: 46px;
    line-height: 30px;
    box-sizing: border-box;

    color: #909399;
    border-bottom: 1px solid #e5e9f2;
  }

  .title-info {
    position: relative;
  }
  .icon {
    color: #999;
    font-size: 14px;
    margin-left: 5px;
  }
  .tip {
    margin-top: 4px;
    font-size: 12px;
    color: #999999;
  }
  /deep/ .el-card__body {
    padding: 23px;
  }
  .list {
    display: flex;
    justify-content: space-between;
    .box-wrap {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-between;
      padding: 23px 40px 26px 23px;
      border-right: 1px solid #e5e9f2;
      &:last-child {
        border-right: none;
      }
      .box-img {
        width: 58px;
        height: 58px;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #ecf2ff;
        border-radius: 50%;
        img {
          width: 30px;
          height: 30px;
        }
      }
    }
    .box-border {
      // margin-right: 24px;
      //   border-right: 1px solid #e5e9f2;
      &:last-child {
        margin-right: 0;
        border-right: none;
      }
    }
    @media screen and (min-width: 1400px) {
      .box-border {
        // margin-right: 64px;
      }
    }
    .box {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: space-between;
      flex: 1;
      .text {
        font-size: 12px;
        color: #999999;
        line-height: 1;
        padding-left: 16px;
      }
      .number {
        font-size: 20px;
        font-weight: bold;
        color: #1b223c;
        margin: 14px 0 16px;
        line-height: 1;
        padding-left: 16px;
      }
      .rate {
        color: #999;
        font-size: 12px;
        display: flex;
        line-height: 1;
        i {
          margin-left: 5px;
          line-height: 12px;
          font-size: 20px;
          font-weight: bold;
        }
      }
      .rate + .rate {
        margin-top: 16px;
      }
    }
  }
  .rate-box {
    padding: 16px;
    background: #fafbfc;
    border-radius: 4px;
    span {
      font-size: 12px;
    }
    .rate-number {
      flex: 1;
      word-break: break-all;
    }
  }
}
.popover-content {
  padding: 24px 18px;
  .container {
    background: #f7f8f9;
    border-radius: 4px;
    padding: 20px 16px;
    display: flex;
    .row {
      display: flex;
      flex-direction: column;
      .item {
        display: flex;
        line-height: 14px;
      }
      .item + .item {
        margin-top: 16px;
      }
      .title {
        font-size: 14px;
        color: #262626;
        margin-right: 8px;
      }
      .data {
        font-size: 12px;
        color: #999;
        flex: 1;
      }
    }
    .row + .row {
      margin-left: 24px;
    }
  }
}
</style>
<style lang="scss">
.chart-popover {
  .el-card__body {
    padding: 0;
  }
}
.card-list {
  .icon {
    color: #999;
    font-size: 14px;
    margin-left: 5px;
  }
}
</style>
